import { Component } from '@angular/core';
import { MarianomGeneral } from '../components/marianom-general.service';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
})

export class AppComponent {
  constructor(private serv: MarianomGeneral, private genServ : EcommerceGenericoService, private modal: ModalService) {

  }

  ngOnInit(): void {
    this.serv.initMaster();
  }

  get nombre() {
    return this.genServ.getNombreSitio();
  }

  get isClosed(): boolean {
    return this.serv.desplegado;
  }
}
